import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  getTelegramWebApp,
  getUserData,
  getColorScheme,
  getPlatform,
  expandApp,
  readyApp,
  setHeaderColor,
  setBackgroundColor,
  isTelegramEnv,
} from '../lib/telegram';

const TelegramContext = createContext(null);

export function TelegramProvider({ children }) {
  const [webApp, setWebApp] = useState(null);
  const [user, setUser] = useState(null);
  const [colorScheme, setColorScheme] = useState('dark');
  const [platform, setPlatform] = useState('unknown');
  const [isReady, setIsReady] = useState(false);
  const [isTelegram, setIsTelegram] = useState(false);

  useEffect(() => {
    const tgApp = getTelegramWebApp();
    const inTelegram = isTelegramEnv();

    setIsTelegram(inTelegram);
    setWebApp(tgApp);
    setUser(getUserData());
    setColorScheme(getColorScheme());
    setPlatform(getPlatform());

    if (inTelegram) {
      // Expand to full screen
      expandApp();

      // Set dark theme header/background
      setHeaderColor('#050B08');
      setBackgroundColor('#050B08');

      // Signal ready
      readyApp();

      // Listen for theme changes
      const handleThemeChanged = () => {
        setColorScheme(getColorScheme());
      };
      tgApp.onEvent('themeChanged', handleThemeChanged);

      setIsReady(true);

      return () => {
        tgApp.offEvent('themeChanged', handleThemeChanged);
      };
    } else {
      // Dev mode - simulate ready
      setIsReady(true);
      console.info('[ENERGYM] Running outside Telegram - dev mode');
    }
  }, []);

  const value = {
    webApp,
    user,
    colorScheme,
    platform,
    isReady,
    isTelegram,
  };

  return (
    <TelegramContext.Provider value={value}>
      {children}
    </TelegramContext.Provider>
  );
}

export function useTelegram() {
  const context = useContext(TelegramContext);
  if (!context) {
    throw new Error('useTelegram must be used within TelegramProvider');
  }
  return context;
}

export default TelegramContext;
